<template>
  <div id="MarketDetails">
    <div class="market">
      <div class="back" @click="back()">
        <span></span>
        返回列表
      </div>
      <main>
        <div class="top">
          <h3><span :class="gf==1?'active':''"><slot></slot>信息</span>{{list.title}}</h3>
          <span class="name">山东淄矿集团</span>
          <span class="time">{{list.time}}发布</span>
        </div>
        <div class="content">
          <div v-for="(item,index) in content" :key="index">
            <p>{{item}}</p>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  name: "MarketDetails",
  props:['showDetails','gf'],
  data() {
    return {
      content: [
        "据中国证券网消息，中国煤炭工业协会会长王显政1日在出席“2017年度全国煤炭交易会”时表示，以签订煤炭中长期合同为切入点，构建煤炭供需双方新型战略合作关系，稳定市场预期，确定数量和质量，明确基础价格+浮动价格的定价模式，达到了煤炭供需双方互利共赢的效果。",
        "煤炭企业有了市场定心丸，不再担心市场份额；用煤企业有了保障定心丸，不再担心资源供应。因此，构建煤炭供需双方新型战略合作关系，既是煤炭上下游企业有效应对煤炭市场形势变化的具体措施，也是企业应对经营风险的理性选择，更是建立煤炭上下游产业协调共赢发展格局的战略选择。",
        "近期，国家发改委组织神华、中煤能源与五大电力企业集团，山西焦煤与部分重点钢铁企业签订了2017年度煤炭供需中长期协议。而在本次交易会上，还有许多煤炭、电力、钢铁、建材大型企业之间将签订年度中长期合同。"
      ],
      list:{title:'煤炭工业协会：长协助煤炭供需方构建新合作关系',time:'2020-02-25'},
      Show:this.showDetails
    };
  },
  mounted(){
    console.log(this.gf)
  },
  methods: {
    back(){
      this.Show=true
    }
  },
  watch:{
    showDetails(val){
      this.Show=val
    },
    Show(val){
      this.$emit("show",val)
    }
  }
};
</script>
<style lang="less" scoped>
.market{
  width: 84%;
  font-size: .16rem;
  border: 1px solid #D9D9D9;
  float: right;
  padding: 0.15rem;
  .back{
    font-size: .18rem;
    color: #57A6F7;
    margin-bottom: 0.2rem;
    cursor: pointer;
    span{
      width: 0.24rem;
      height: 0.24rem;
      display: inline-block;
      background: url(../assets/Conversion/back.png) no-repeat;
      background-size: 100% 100%;
      margin-right: 0.1rem;
      vertical-align: bottom;
    }
    .type{
      background: #fa621f;
    }
  }
  main{
    width: 85%;
    margin: 0 auto;
    .top{
      text-align: center;
      h3{
        font-size: .2rem;
        color: #131313;
        font-weight: 400;
        margin-bottom: 0.2rem;
        span{
          font-size: .16rem;
          background: #3E71C7;
          color: #fff;
          border-radius: .04rem;
          padding: 0.07rem;
          margin-right: 0.16rem;
        }
        .active{
          background:#fa621f
        }
      }
      span{
        color: #838383;
      }
      span.name{
        margin-right: .2rem;
      }
    }
    .content{
      margin-top: 0.5rem;
      color: #1D1D1D;
      p{
        text-indent: 2em;
        margin-bottom: 0.3rem;
      }
    }
  }
}
</style>